import React from "react";
import "./gradientBorderElement.scss";

const GradientBorderElement = ({ content, customGradient, customInnerBackground }) => {
    return (
        <div className="GradientBorderElement" style={customGradient ? { background: customGradient } : null }>
            <div className="GradientBorderElement__mask">
                <div className="GradientBorderElement__content" style={customInnerBackground ? { background: customInnerBackground } : null}>
                    {content}
                </div>
            </div>
        </div>
    );
};

export default GradientBorderElement;